import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full border-b border-gray-200" }
const _hoisted_2 = { class: "text-base leading-5 tracking-[0.01rem] text-primary-text-color font-semibold pb-[20px]" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "flex gap-[8px] pb-[20px]" }
const _hoisted_5 = { class: "flex items-center cursor-pointer" }
const _hoisted_6 = { class: "flex items-center cursor-pointer" }

import { ref, watch } from "vue";
import { useTranslate } from "@/composables/useTranslate";

type Emits = {
  (event: "onOptionUpdate", option: string[]): void;
};

type Props = {
  selectedViewOptions: string[];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewOptionsFilter',
  props: {
    selectedViewOptions: {}
  },
  emits: ["onOptionUpdate"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

const tempSelectedViewOptions = ref<string[]>([...props.selectedViewOptions]);
const { t } = useTranslate();

watch(
  () => props.selectedViewOptions,
  (newVal) => {
    tempSelectedViewOptions.value = [...newVal];
  },
  { deep: true, immediate: true }
);

const onUpdateViewOpton = (option: string) => {
  if (tempSelectedViewOptions.value.includes(option)) {
    tempSelectedViewOptions.value = tempSelectedViewOptions.value.filter(
      (item) => item !== option
    );
  } else {
    tempSelectedViewOptions.value.push(option);
  }
  emits("onOptionUpdate", tempSelectedViewOptions.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _createTextVNode(_toDisplayString(_unref(t)("home.type_of_project")) + " ", 1),
      (tempSelectedViewOptions.value.length > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (" + _toDisplayString(tempSelectedViewOptions.value.length) + ") ", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onUpdateViewOpton('commercial'))),
          class: _normalizeClass([
            'px-[8px] py-[12px] rounded-[14px] text-sm',
            tempSelectedViewOptions.value.includes('commercial')
              ? 'bg-[#D1CFF7] text-gray-800'
              : 'bg-gray-200 text-gray-800',
          ])
        }, " Commercial ", 2)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onUpdateViewOpton('residential'))),
          class: _normalizeClass([
            'px-[8px] py-[12px] rounded-[14px] text-sm',
            tempSelectedViewOptions.value.includes('residential')
              ? 'bg-[#D1CFF7] text-gray-800'
              : 'bg-gray-200 text-gray-800',
          ])
        }, " Residential ", 2)
      ])
    ])
  ]))
}
}

})